export const countDigits = (value: number) =>
  Math.max(Math.floor(Math.log10(Math.abs(value))), 0) + 1

export const limitDecimals = (num: number, precision = 2) => {
  const [int, decimals] = String(num).split('.')

  if (decimals === undefined) {
    return int
  }

  // allow the user to input until we reach precision limit
  if (decimals.length < precision) {
    return `${int}.${decimals}`
  }

  const slicedDecimal = decimals.slice(0, precision)

  const eliminateTrailingZeros = (value: string): string => {
    const result =
      value[value.length - 1] === '0' ? value.slice(0, value.length - 1) : value

    if (result[result.length - 1] === '0') {
      return eliminateTrailingZeros(result)
    } else {
      return result
    }
  }

  const trimmedDecimal = eliminateTrailingZeros(slicedDecimal)

  return `${int}.${trimmedDecimal}`
}
